module.exports = ".group-buttons{\r\n    text-align: center !important;\r\n}\r\n.box-product{\r\n    width: 100%;\r\n}\r\n.group-buttons{\r\n    text-align: center !important;\r\n}\r\n.box-product{\r\n    width: 100%;\r\n}\r\n.product-item{\r\n    width: 32.3%;\r\n}\r\n@media (min-width: 580px) and (max-width:1200px){\r\n    .product-item{\r\n        width: 326%;\r\n      \r\n        height: 50vh;\r\n       \r\n    }\r\n   \r\n     \r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trending/trending.component.css
// module id = ./src/app/components/trending/trending.component.css
// module chunks = main